module.exports = __webpack_public_path__ + "img/video-preview-xs.f41e247.jpg";